"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = exports.IWrapperFull = exports.IWrapper = exports.ISize = void 0;
const io_1 = require("./io");
const ejf_1 = require("./ejf");
const ejo_1 = require("./ejo");
const si_1 = require("./si");
const ix_1 = require("./ix");
__exportStar(require("./io"), exports);
__exportStar(require("./ejf"), exports);
__exportStar(require("./ejo"), exports);
__exportStar(require("./si"), exports);
__exportStar(require("./ix"), exports);
var ISize;
(function (ISize) {
    ISize[ISize["SL"] = 16] = "SL";
    ISize[ISize["SM"] = 24] = "SM";
    ISize[ISize["MD"] = 32] = "MD";
    ISize[ISize["LG"] = 64] = "LG";
})(ISize || (exports.ISize = ISize = {}));
const emptyFunc = (props) => {
    return null;
};
const IWrapper = (x) => {
    return io_1.IOWrapper[x] || ejf_1.EJFWrapper[x] || ejo_1.EJOWrapper[x] || si_1.SIWrapper[x] || ix_1.IXWrapper[x] || emptyFunc;
};
exports.IWrapper = IWrapper;
const IWrapperFull = () => {
    return {
        ...io_1.IOWrapper,
        ...ejf_1.EJFWrapper,
        ...ejo_1.EJOWrapper,
        ...si_1.SIWrapper,
        ...ix_1.IXWrapper
    };
};
exports.IWrapperFull = IWrapperFull;
function getIcon(name) {
    return (0, exports.IWrapper)(name);
}
exports.getIcon = getIcon;
